import React from 'react';

import { LoadingOverlay } from '@/components/loading-overlay/loading-overlay';
import dayjs from 'dayjs';
import {
  CartesianGrid,
  Cell,
  Legend,
  Line,
  LineChart,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import {
  IDashboardSummaryChart, IDashboardSummaryDaily,
} from '@/modules/dashboard/summary/model/summary';

const DashboardSummaryChart: React.FC<{
  chartData: IDashboardSummaryChart,
  dailyData: IDashboardSummaryDaily[],
  isLoading: boolean;
}> = (props) => {
  const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

  return (
    <div className="bg-white p-5 rounded-xl mb-5">
      <LoadingOverlay isLoading={props?.isLoading}>
        <span className="text-lg font-bold">Chart</span>

        <div className="grid grid-cols-4 gap-4 mt-4 text-center">
          <div className="shadow-md rounded-lg border border-gray-200 col-span-3">
            <div className="text-sm font-bold bg-gray-100 rounded-t-lg p-2">Order Harian</div>
            <div className="text-2xl font-bold pt-6 pb-6 text-sky-500">
              <ResponsiveContainer width="100%" height={300}>
                <LineChart
                  data={props?.dailyData}
                  margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5,
                  }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey={({ order_date }) => dayjs(order_date).format('DD/MM/YYYY')} tick={{ fontSize: 10 }} />
                  <YAxis tick={{ fontSize: '10px' }} />
                  <Tooltip wrapperStyle={{ fontSize: '10px' }} />
                  <Legend wrapperStyle={{ fontSize: '14px' }} />
                  <Line type="monotone" name="Total Order" dataKey="total_order" stroke="#8884d8" activeDot={{ r: 8 }} />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </div>

          <div className="shadow-md rounded-lg border border-gray-200">
            <div className="text-sm font-bold bg-gray-100 rounded-t-lg p-2">
              Jenis Layanan
            </div>
            <div className="pt-4 pb-4">
              <ResponsiveContainer width="100%" height={300}>
                <PieChart>
                  <Pie
                    dataKey="total_order"
                    data={props?.chartData?.services}
                    outerRadius="70%"
                    fill="#8884d8"
                    label={({ product_service_code }) => product_service_code}
                    fontSize={10}
                  >
                    {props?.chartData?.services?.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                    ))}
                  </Pie>
                  <Tooltip />
                </PieChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
      </LoadingOverlay>
    </div>
  );
};

export default DashboardSummaryChart;
